export function remainingSeconds(expiresAt: number, now: number) {
  if (!Number.isFinite(expiresAt) || !Number.isFinite(now)) return 0
  return Math.max(0, Math.floor((expiresAt - now) / 1000))
}

export function formatCountdown(seconds: number) {
  const safe = Math.max(0, Math.floor(Number.isFinite(seconds) ? seconds : 0))
  return `${String(Math.floor(safe / 60)).padStart(2, '0')}:${String(safe % 60).padStart(2, '0')}`
}
